export default function TemplatePartMenuItems() {
	return null;
}
